module.exports = __webpack_public_path__ + "img/3-low.d82e4cf3.jpg";